import React, { useEffect, useState } from 'react';
import { Home, List, Heart, User, Play } from 'lucide-react';
import { useNavigate, NavLink } from 'react-router-dom';

export default function MobileNav() {
    const navigate = useNavigate();

    const [categories, setCategories] = useState(null);  // Start with null to handle loading state
    const [loading, setLoading] = useState(true);         // Loader state
    const [isMobile, setIsMobile] = useState(false);      // State to track if it's a mobile screen

    useEffect(() => {
        const storedCategories = sessionStorage.getItem('Laki_content');
        
        if (storedCategories) {
            setCategories(JSON.parse(storedCategories));  // Parse and set categories from sessionStorage
            setLoading(false);  // Data loaded, stop loading
        } else {
            setTimeout(() => {
                setCategories([]);  // Set empty array if no categories (or set a real value)
                setLoading(false);   // Stop loading after simulation
            }, 2000);  
        }

        // Function to detect mobile screen size
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true);  // If width is less than or equal to 768px, set as mobile
            } else {
                setIsMobile(false); // Otherwise, it's not mobile
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const handleCategoryClick = (cat) => {
        navigate('/category', { state: { category: cat } });
    
        // Manually hide the offcanvas
        const offcanvas = document.getElementById("offcanvasBottom");
        if (offcanvas) {
            offcanvas.classList.remove("show");
            offcanvas.style.visibility = "hidden";
            offcanvas.setAttribute("aria-hidden", "true");
            offcanvas.removeAttribute("aria-modal");
            offcanvas.removeAttribute("role");
    
            // Remove backdrop
            const backdrop = document.querySelector(".offcanvas-backdrop");
            if (backdrop) backdrop.remove();
    
            // Restore body scrolling
            document.body.classList.remove("offcanvas-backdrop", "modal-open");
            document.body.style.overflow = '';
        }
    };

    // Return null if not mobile
    if (!isMobile) return null;

    
    return (
        <>
            {/* Offcanvas Bottom */}
            <div style={{ height: '50vh' }}
                className="offcanvas offcanvas-bottom"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasBottomLabel">Categories</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="offcanvas-body small">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : categories && categories.length > 0 ? (
                        categories.map((cat, index) => (
                            <div 
                                className="d-flex flex-row align-items-center mb-2 pb-3" 
                                style={{ borderBottom: '1px solid var(--main-pink)' }} 
                                key={index}
                                onClick={() => handleCategoryClick(cat)}>
                                
                                <h5 className="m-0">{cat.Name}</h5>
                            </div>
                        ))
                    ) : (
                        <div>No Categories Available</div>
                    )}
                </div>
            </div>

            <nav className="mobile-nav">
                <NavLink to="/home" className="nav-item">
                    <Home size={24} />
                    <span>Home</span>
                </NavLink>

                <button className="nav-item btn p-0 border-0 bg-transparent" type="button" data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom">
                    <List size={24} />
                    <span>Categories</span>
                </button>

                <NavLink to="/favorites" className="nav-item">
                    <Heart size={24} />
                    <span>Favorites</span>
                </NavLink>

                <NavLink to="/profile" className="nav-item">
                    <User size={24} />
                    <span>Profile</span>
                </NavLink>
            </nav>
        </>
    );
}
